import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import fr from 'vuetify/es5/locale/fr'
import * as directives from 'vuetify/es5/directives'

Vue.use(Vuetify, {
  theme: {
    primary: '#42a5f5',
    secondary: '#3f51b5',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  iconfont: 'md',
  lang: {
    locales: { fr },
    current: 'fr'
  },
  directives
})
